import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DriveBrowser from '../DriveBrowser';
import { DRIVE_ROOT_FOLDER_ID } from '@/types/docflow';
import type { INodeConfig } from '@/types/docflow';

interface DriveMoveConfigProps {
  config: INodeConfig;
  onChange: (config: INodeConfig) => void;
}

const DriveMoveConfig: React.FC<DriveMoveConfigProps> = ({ config, onChange }) => {
  const { t } = useTranslation('docflow');
  const [showBrowser, setShowBrowser] = useState(false);

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
        {t('node.driveMove')}
      </h3>

      {/* Destination folder */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {t('config.destinationFolder')}
        </label>
        <div className="flex items-center gap-2">
          <div className="flex-1 text-sm px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 dark:text-gray-200 truncate">
            {config.destination_folder_name || t('config.noDestination')}
          </div>
          <button
            type="button"
            onClick={() => setShowBrowser(true)}
            className="px-3 py-2 text-sm bg-cyan-100 dark:bg-cyan-900 text-cyan-700 dark:text-cyan-300 rounded-lg hover:bg-cyan-200 dark:hover:bg-cyan-800"
          >
            {t('config.browseFolders')}
          </button>
        </div>
        {config.destination_folder_id && (
          <p className="mt-1 text-xs text-gray-400 dark:text-gray-500 font-mono truncate">
            ID: {config.destination_folder_id}
          </p>
        )}
      </div>

      <p className="text-xs text-gray-500 dark:text-gray-400">
        {t('config.driveMoveHint')}
      </p>

      {showBrowser && (
        <DriveBrowser
          isOpen={showBrowser}
          onClose={() => setShowBrowser(false)}
          mode="folder"
          rootFolderId={DRIVE_ROOT_FOLDER_ID}
          onSelectFolder={(folderId, folderName) => {
            onChange({ ...config, destination_folder_id: folderId, destination_folder_name: folderName });
          }}
        />
      )}
    </div>
  );
};

export default DriveMoveConfig;
